import React from 'react'

const STRKUSD = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='48' height='48' viewBox='0 0 48 48' fill='none'>
      <g clipPath='url(#clip0_3872_20577)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M0.0496979 24.3755C0.0496979 37.6305 10.7947 48.3755 24.0497 48.3755C37.3046 48.3755 48.0504 37.6305 48.0504 24.3755C48.0504 11.1205 37.3046 0.375488 24.0497 0.375488C10.7947 0.375488 0.0496979 11.1205 0.0496979 24.3755Z'
          fill='#0C0C4F'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M14.6396 19.3744L15.1621 17.76C15.2683 17.4317 15.5275 17.1762 15.857 17.0755L17.4793 16.5765C17.7039 16.5079 17.7057 16.1911 17.4829 16.119L15.868 15.5964C15.5402 15.4902 15.2847 15.2311 15.1834 14.9015L14.6851 13.2791C14.6165 13.0552 14.2997 13.0527 14.2274 13.2762L13.7049 14.8906C13.5987 15.2182 13.3395 15.4737 13.01 15.5751L11.3877 16.0734C11.1631 16.1426 11.1607 16.4588 11.3841 16.531L12.9991 17.0535C13.3268 17.1598 13.5823 17.4195 13.6836 17.7491L14.1819 19.3707C14.2505 19.5953 14.5673 19.5978 14.6396 19.3744Z'
          fill='#FAFAFA'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M40.2816 18.4347C39.6128 17.6869 38.569 17.2657 37.5543 17.0931C36.5314 16.9272 35.459 16.9426 34.4491 17.122C32.406 17.4677 30.5498 18.3137 28.931 19.3573C28.0902 19.8695 27.3733 20.4621 26.6305 21.0658C26.2727 21.371 25.9463 21.6961 25.6065 22.0165L24.6779 22.9404C23.6691 23.995 22.6746 24.9555 21.7124 25.7518C20.7463 26.5443 19.8431 27.1461 18.9531 27.5665C18.0635 27.9891 17.1116 28.2375 15.8711 28.2773C14.6414 28.3207 13.1865 28.0987 11.6302 27.7324C10.0656 27.3677 8.42261 26.8478 6.58659 26.4005C7.22722 28.1778 8.19194 29.7484 9.4305 31.184C10.6836 32.5948 12.2483 33.8806 14.2585 34.7263C16.2395 35.5907 18.7291 35.9009 21.057 35.4328C23.391 34.9836 25.4393 33.9035 27.0948 32.6545C28.7546 31.3926 30.0976 29.9552 31.2296 28.4609C31.5422 28.048 31.7075 27.817 31.9337 27.4943L32.5587 26.5684C32.9932 25.9955 33.3886 25.3434 33.8185 24.776C34.6616 23.5875 35.4926 22.4005 36.4584 21.3069C36.9446 20.7521 37.4569 20.2216 38.062 19.7117C38.3639 19.4628 38.69 19.2192 39.0511 18.9998C39.4178 18.7632 39.8049 18.5779 40.2816 18.4347Z'
          fill='url(#paint0_linear_3872_20577)'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M40.2817 18.4346C39.5632 16.6215 38.2276 15.0954 36.4347 13.9693C34.6528 12.8555 32.1778 12.2871 29.7253 12.7716C28.5137 13.006 27.34 13.4571 26.3098 14.0578C25.2844 14.6563 24.3655 15.3765 23.5701 16.1494C23.173 16.537 22.8125 16.9414 22.4544 17.3481L21.5262 18.5315L20.0927 20.4363C18.2651 22.8872 16.2971 25.7594 13.0675 26.6104C9.89692 27.446 8.52178 26.706 6.5867 26.4004C6.94052 27.3139 7.37881 28.2009 7.97298 28.9814C8.55608 29.7777 9.24482 30.5255 10.1011 31.1665C10.5338 31.4744 10.9907 31.7783 11.4981 32.036C12.0032 32.285 12.5479 32.5041 13.1294 32.6691C14.2859 32.9861 15.5878 33.0972 16.8485 32.9267C18.1098 32.7584 19.3154 32.3587 20.3691 31.8278C21.4306 31.302 22.3553 30.6616 23.181 29.9857C24.8224 28.6227 26.0992 27.1166 27.1776 25.5942C27.72 24.833 28.2124 24.0574 28.6678 23.2817L29.2038 22.3583C29.3677 22.0883 29.5334 21.8167 29.7018 21.5637C30.3809 20.5473 31.0452 19.7323 31.852 19.1207C32.6477 18.4931 33.7555 18.0295 35.2361 17.9218C36.7104 17.8129 38.4125 18.0142 40.2817 18.4346Z'
          fill='#FAFAFA'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M32.3053 33.498C32.3053 34.8296 33.3853 35.9096 34.7169 35.9096C36.0485 35.9096 37.1272 34.8296 37.1272 33.498C37.1272 32.1664 36.0485 31.0864 34.7169 31.0864C33.3853 31.0864 32.3053 32.1664 32.3053 33.498Z'
          fill='#EC796B'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_3872_20577'
          x1='40.1014'
          y1='17.7985'
          x2='-14.9645'
          y2='46.4483'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#EC796B' />
          <stop offset='1' stopColor='#D672EF' />
        </linearGradient>
        <clipPath id='clip0_3872_20577'>
          <rect width='48' height='49.2' fill='white' transform='translate(0 -0.600098)' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default STRKUSD
